// The bottom action bar on the Recipes and Plan tabs (feature spec 05): it
// slides up once something is ticked, carrying what Add to list will shop for,
// and goes again when the selection is cleared. Nothing ticked, no bar — the
// tick circles on the cards say what to do.

interface Line { title: string; subtitle?: string }

export function ActionBar({ selected, onAdd, onClear }: {
  /** What is ticked, or nothing. */
  selected?: Line | null
  onAdd: () => void
  /** Recipes offers Clear; the Plan bar has none. */
  onClear?: () => void
}) {
  if (!selected) return null
  return (
    <div className="ml-action-bar" role="region" aria-label="Shopping selection">
      <div className="ml-action-bar__text" aria-live="polite">
        <span className="ml-action-bar__title">{selected.title}</span>
        {selected.subtitle && <span className="ml-action-bar__subtitle">{selected.subtitle}</span>}
      </div>
      {onClear && (
        <button type="button" className="ml-action-bar__clear" onClick={onClear}>Clear</button>
      )}
      <button type="button" className="ml-action-bar__add" onClick={onAdd}>
        Add to list
      </button>
    </div>
  )
}
